import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUser } from "@/context/userContext";
import { useGuestUser } from "@/context/GuestUserContext";

/**
 * GuestOnlyRoute
 * Restricts access to public routes like login, signup, etc.
 * Redirects authenticated or guest users to the home page.
 */
const GuestOnlyRoute: React.FC = () => {
    const { user, loading: userLoading } = useUser();
    const { guestUser } = useGuestUser();
    const location = useLocation();

    // While checking user session
    if (userLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
                <span className="brand-pill qit-loading-pill qit-loading-pill-page" aria-label="Loading" />
            </div>
        );
    }

    // Redirect if user is authenticated or guest session exists
    if (user || guestUser) {
        return <Navigate to="/home" replace state={{ from: location }} />;
    }

    // Allow access to child routes
    return <Outlet />;
};

export default GuestOnlyRoute;
